import { useTheme } from "@material-ui/core/styles";
import { useI18n } from "../../../hooks/useI18n";
import { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogProps,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  FormControl,
  InputAdornment,
  InputLabel,
  Link,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import IconButton from "@material-ui/core/IconButton";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import {
  CheckCircleOutline,
  Clear,
  HighlightOff,
  MeetingRoom,
  StoreOutlined,
  TabletAndroid,
  Timer
} from "@mui/icons-material";
import ChatIcon from "@mui/icons-material/Chat";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@material-ui/icons/Close";
import SyncIcon from "@mui/icons-material/Sync";
import {
  emptyStore,
  StoreOrderItem,
  StoreOrderState,
  toWriteModel
} from "../../../models/Store";
import { DoorOpenModal } from "../../../components/dialogs/DoorOpenModal";
import Divider from "@material-ui/core/Divider";
import useStyles from "../styles";
import { Authenticated, hasRole } from "../../../models/User";
import { StoreEditor } from "../../stores/StoreList/components/StoreEditor";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../UserProvider";
import { ActionStatuses, UpsertStoreState } from "../../stores/StoreList/types";
import StoreUserEventsDialog from "./components/StoreUserEventsDialog";
import { BadgeNotifications } from "../../../components/information/notification/BadgeNotifications";
import CommunicationDialog from "./components/CommunicationDialog";
import { ConfirmDialog } from "../../../components/dialogs/ConfirmDialog";

import * as StoreApi from "../../../api/storeApi";
import { isOk } from "../../../result";
import { Alert, AlertTitle } from "@material-ui/lab";
import { DropzoneArea } from "material-ui-dropzone";
import { SpoilageReasonSelect } from "../../../components/selects/SpoilageReasonSelect";
import { OrderUnit } from "../../../models/Order";
import { emptyProduct } from "../../../models/Product";
import { globalSettings } from "../../../models/Settings";
import { thunkFetchProductsV2 } from "../../../store/products/action";
import { StoreOrderSelect } from "../../stores/ProductDelivery/StoreOrderSelect";
import { TenantProductEditor } from "../../tenants/Products/TenantProductEditor";
import * as StoreInventoryApi from "../../../api/storeInventoryApi";
import * as ProductApi from "../../../api/productApi";
import * as StoreOrderApi from "../../../api/storeOrderApi";
import { ConnectToPriceTag } from "../../tenants/Products/ConnectToPriceTag";
import { ScanditBarcodeScanner } from "../../../components/ScanditBarcodeScanner";
import { useStoresQuery } from "../../../queries/stores";
import { getFilteredStores } from "../../../store/stores/utils";

const initialUpsertStoreState = (): UpsertStoreState => ({
  showDialog: false,
  newStore: false,
  store: emptyStore()
});

export const MyStoreMenu = ({ ...props }: any) => {
  const theme = useTheme();
  const classes = useStyles();
  const { t } = useI18n();
  const isSmallDown = useMediaQuery(theme.breakpoints.down("sm"));
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const user = useContext(UserContext) as Authenticated;
  const [open, setOpen] = useState(false);
  const [controllers, setControllers] = useState<any>([]);
  const navigate = useNavigate();

  const [dialogOpen, setDialogOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const [state, setState] = useState<any>({
    uploading: false,
    upsertStore: initialUpsertStoreState(),
    showProductDelivery: false,
    storeId: null,
    displayConfirmUpdatePriceTags: false,
    actionStatus: 0,
    reloadControllerStatus: true,
    activeTabs: new Map(),
    productDelivery: { storeId: undefined, showDialog: false },
    showModel: false,
    showEventsModel: false,
    showMobilePOSReceiptsModel: false,
    showStoreEditor: false,
    showCashierReportModel: false,
    showCommunicationDialog: false,
    selectedStore: {},
    showConnectToPriceTag: false
  });

  const { data: stores = [] } = useStoresQuery();

  // useEffect(() => {
  //   const fetchControllerStatuses = async (storeList: any) => {
  //     setState({ ...state, reloadControllerStatus: false });
  //     let controllerStatuses = [];
  //     for (let i = 0; i < storeList.length; i++) {
  //       let statusResponse = await getStoreControllerStatus(stores[i].id);
  //       controllerStatuses.push({
  //         storeId: stores[i].id,
  //         status:
  //           statusResponse.type === "OK" ? statusResponse.value : "Unknown"
  //       });
  //     }
  //     setControllers(controllerStatuses);
  //   };

  //   if (stores && stores.length && state.reloadControllerStatus) {
  //     fetchControllerStatuses(stores);
  //   }
  // }, [stores]);

  useEffect(() => {
    const selectableStores = getFilteredStores(stores);
    setState({
      ...state,
      showModal: false,
      selectedStore: null,
      selectableStores: selectableStores.filter(
        x => x.state === "Opened" || x.state === "InSetup"
      )
    });
  }, [stores]);

  useEffect(() => {
    const handleResize = () => {
      setOpen(false);
      setDialogOpen(false);
      setState({
        ...state,
        showModal: false
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current && !open) {
      anchorRef.current!.focus();
    }
    prevOpen.current = open;
  }, [open]);

  /* Dialog */
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");

  const descriptionElementRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (dialogOpen) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [dialogOpen]);

  const upsertStoresRefreshHandler = (success: boolean) => {
    if (success) {
      setState({
        ...state,
        upsertStore: initialUpsertStoreState(),
        actionStatus: ActionStatuses.UPSERT_STORE_SUCCESS,
        reloadControllerStatus: state.upsertStore.newStore
      });
      navigate(".", { replace: true });
    } else {
      setState({
        ...state,
        upsertStore: { ...state.upsertStore, showDialog: true }
      });
    }
  };

  const editStoreAction = (storeId: string) => {
    const store = stores.find(s => s.id === storeId);
    if (store != null) {
      setState({
        ...state,
        upsertStore: {
          store: toWriteModel(store, false),
          showDialog: true,
          newStore: false
        }
      });
    }
  };

  const updatePriceTagsAction = (storeId: string) => {
    setState({
      ...state,
      displayConfirmUpdatePriceTags: true,
      storeId: storeId
    });
  };

  const loadProduct = async (gtin: string) => {
    setState({
      ...state,
      isLoading: true,
      getItemFailed: false
    });

    try {
      const result = await StoreInventoryApi.getSingleByGTIN(
        state.selectedStoreId,
        gtin
      );

      if (result.type === "OK") {
        const { value } = result;
        const { product } = value;
        setState({
          ...state,
          isLoading: false,
          manualInput: gtin,
          deliveryItem: {
            productId: product.id,
            orderInfo: product.orderInfo,
            gtin: product.gtin,
            productName: product.name,
            brandName: product.brandName,
            size: product.details?.size,
            onShelfBeforeDelivery: value.onShelf,
            correctedOnShelf: value.onShelf,
            quantityDelivered:
              product.orderInfo?.distributionPackageSize ?? undefined
          },
          scanning: false,
          delivering: true
        });
      } else {
        if (result.details.status === 404) {
          if (result.details.detail === "ProductNotRegistered") {
            setState({
              ...state,
              isLoading: false,
              scanning: false,
              manualInput: gtin,
              registeringInSystem: true
            });
          } else {
            setState({
              ...state,
              isLoading: false,
              scanning: false,
              manualInput: gtin,
              registeringInStore: true
            });
          }
        } else {
          setState({
            ...state,
            isLoading: false,
            getItemFailed: true,
            error: result.details.detail
          });
        }
      }
    } catch (error) {
      setState({
        ...state,
        isLoading: false,
        getItemFailed: true,
        error: "An unexpected error occurred"
      });
    }
  };

  const totalQuantityDelivered = () => {
    const {
      deliveryItem: { correctedOnShelf, quantityDelivered }
    } = state;
    return (isNaN(correctedOnShelf) ? 0 : correctedOnShelf) + quantityDelivered;
  };

  return (
    <div style={{ display: "flex" }}>
      <div>
        <IconButton
          className={classes.menuButton}
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow-door" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <StoreOutlined className={classes.icon} />
          <Typography
            variant="subtitle2"
            component="span"
            className={classes.text}
          >
            {stores?.length
              ? user?.tenant?.customerId
                ? `${user.tenant.customerId} - ${stores[0].name}`
                : stores[0].name
              : "Loading..."}
          </Typography>
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom"
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow-door"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem key={stores[0].id}>
                      <Box
                        sx={{
                          width: { xs: "100%", sm: "100%", md: 400 },
                          padding: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                          // gap: "12px",
                          // flexDirection: { xs: "column", sm: "row" }
                        }}
                      >
                        {stores[0].state === "Opened" ? (
                          <Button
                            startIcon={
                              <CheckCircleOutline
                                style={{ color: "green", fontSize: "18px" }}
                              />
                            }
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              padding: { xs: "4px 8px", md: "6px 12px" }
                            }}
                          >
                            Opened
                          </Button>
                        ) : (
                          <Button
                            startIcon={
                              <Timer
                                style={{ color: "orange", fontSize: "18px" }}
                              />
                            }
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              padding: { xs: "4px 8px", md: "6px 12px" }
                            }}
                          >
                            Not Opened
                          </Button>
                        )}

                        {stores[0].controllerConnectionState === "Online" ? (
                          <Button
                            startIcon={
                              <CheckCircleOutline
                                style={{ color: "green", fontSize: "18px" }}
                              />
                            }
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              padding: { xs: "4px 8px", md: "6px 12px" }
                            }}
                          >
                            Online
                          </Button>
                        ) : (
                          <Button
                            startIcon={
                              <HighlightOff
                                style={{ color: "red", fontSize: "18px" }}
                              />
                            }
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              padding: { xs: "4px 8px", md: "6px 12px" }
                            }}
                          >
                            Offline
                          </Button>
                        )}

                        <Button
                          onClick={() => editStoreAction(stores[0].id)}
                          startIcon={<EditIcon style={{ fontSize: "18px" }} />}
                          sx={{
                            fontSize: { xs: "12px", md: "14px" },
                            padding: { xs: "4px 8px", md: "6px 12px" }
                          }}
                        >
                          Edit
                        </Button>
                      </Box>
                    </MenuItem>
                    <Divider />
                    <MenuItem>
                      <Button
                        onClick={() =>
                          setState({
                            ...state,
                            showOpenDoorDialog: true,
                            selectedStore: stores[0]
                          })
                        }
                        startIcon={<MeetingRoom style={{ fontSize: "18px" }} />}
                        sx={{
                          fontSize: { xs: "12px", md: "14px" },
                          padding: { xs: "4px 8px", md: "6px 12px" }
                        }}
                      >
                        Open Door
                      </Button>
                    </MenuItem>
                    <Divider />

                    {user.tenant?.configuration?.features?.delivery && (
                      <>
                        <MenuItem>
                          <Button
                            onClick={() => {
                              if (
                                user.tenant?.configuration?.features
                                  ?.centralOrderingSystem
                              ) {
                                setState({
                                  ...state,
                                  chooseDeliveryType: true,
                                  selectedStoreId: stores[0].id,
                                  selectedStoreName: stores[0].name,
                                  productDelivery: {
                                    showDialog: true
                                  }
                                });
                              } else if (
                                user.tenant?.configuration?.features
                                  ?.deliveryThroughFileUpload
                              ) {
                                setState({
                                  ...state,
                                  uploadProductFile: true,
                                  selectedStoreId: stores[0].id,
                                  selectedStoreName: stores[0].name,
                                  productDelivery: {
                                    showDialog: true
                                  }
                                });
                              } else {
                                setState({
                                  ...state,
                                  scanning: true,
                                  selectedStoreId: stores[0].id,
                                  selectedStoreName: stores[0].name,
                                  productDelivery: {
                                    showDialog: true
                                  }
                                });
                              }
                            }}
                            startIcon={
                              <LocalShippingIcon style={{ fontSize: "18px" }} />
                            }
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              padding: { xs: "4px 8px", md: "6px 12px" }
                            }}
                          >
                            Delivery
                          </Button>
                        </MenuItem>
                        <Divider />
                      </>
                    )}

                    {stores[0].config.priceTags?.provider === "PricerRest" && (
                      <>
                        <MenuItem>
                          <Button
                            onClick={() => updatePriceTagsAction(stores[0].id)}
                            startIcon={
                              <SyncIcon style={{ fontSize: "18px" }} />
                            }
                            sx={{
                              fontSize: { xs: "12px", md: "14px" },
                              padding: { xs: "4px 8px", md: "6px 12px" }
                            }}
                          >
                            Sync price tags
                          </Button>
                        </MenuItem>
                        <Divider />
                      </>
                    )}

                    {!hasRole(user, ["DistributorManager"]) && (
                      <MenuItem>
                        <BadgeNotifications style={{ marginRight: "8px" }} />
                        Messages
                      </MenuItem>
                    )}
                    <Divider />
                    <MenuItem
                      onClick={() =>
                        setState({
                          ...state,
                          showCommunicationDialog: true,
                          selectedStore: stores[0]
                        })
                      }
                    >
                      <ChatIcon style={{ marginRight: "8px" }} /> Communication
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>

      <StoreUserEventsDialog
        open={state.showEventsModel || false}
        onClose={() => {
          setState({
            ...state,
            showEventsModel: false
          });
        }}
      />

      <CommunicationDialog
        open={state.showCommunicationDialog || false}
        onClose={() => {
          setState({
            ...state,
            showCommunicationDialog: false
          });
        }}
      />

      <ConfirmDialog
        visible={state.displayConfirmUpdatePriceTags}
        titleText={"Are you sure?"}
        confirmText={"Yes"}
        cancelText={"No"}
        onCancel={() =>
          setState({
            ...state,
            displayConfirmUpdatePriceTags: false,
            storeId: null
          })
        }
        onConfirm={async () => {
          if (!state.displayConfirmUpdatePriceTags && state.storeId === null) {
            return true;
          }

          const result = await StoreApi.syncAllPriceTags(state.storeId ?? "");

          setState({
            ...state,
            displayConfirmUpdatePriceTags: false,
            storeId: state.storeId
          });

          setState({
            ...state,
            actionStatus: isOk(result)
              ? ActionStatuses.UPDATE_PRICETAGS_SUCCESS
              : ActionStatuses.UPDATE_PRICETAGS_ERROR
          });

          return true;
        }}
      >
        Do you want to re-sync all digital price tags in{" "}
        <strong>
          {!stores.length ? "" : stores.find(s => s.id === state.storeId)?.name}
        </strong>
        ?
      </ConfirmDialog>

      <Dialog
        fullWidth
        fullScreen={isSmallDown}
        maxWidth={"md"}
        open={state.upsertStore.showDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MuiDialogTitle>
          {state.upsertStore.newStore
            ? t("common.actions.createStore")
            : t("common.actions.editStore")}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setState({
                ...state,
                showOpenDoorDialog: false,
                upsertStore: initialUpsertStoreState()
              });
              // navigate(".", { replace: true });
            }}
          >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent dividers>
          {state.upsertStore.newStore ? (
            <StoreEditor
              currentUser={user as Authenticated}
              store={emptyStore()}
              isSuccessHandler={upsertStoresRefreshHandler}
            />
          ) : (
            <StoreEditor
              currentUser={user as Authenticated}
              store={state.upsertStore.store}
              isSuccessHandler={upsertStoresRefreshHandler}
            />
          )}
        </DialogContent>
      </Dialog>
      <DoorOpenModal
        visible={state.showOpenDoorDialog}
        store={state.selectedStore}
        onCancel={() =>
          setState({
            ...state,
            showOpenDoorDialog: false
          })
        }
      />

      <Dialog
        fullWidth={true}
        fullScreen={mobile}
        maxWidth={"md"}
        open={state.productDelivery.showDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MuiDialogTitle disableTypography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setState({
                ...state,
                manualInput: undefined,
                productDelivery: { showDialog: false, storeId: undefined },
                showScanner: false,
                scanning: undefined,
                delivering: undefined,
                deliverySuccess: undefined,
                registeringInStore: undefined,
                registeringInSystem: undefined,
                showRegisterProduct: undefined,
                registeringSuccess: undefined,
                registerFailed: false,
                chooseDeliveryType: false,
                file: undefined,
                hasProductDeliveryResult: false,
                productDeliveryFailed: undefined,
                deliveryResult: undefined
              });
            }}
          >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        {state.chooseDeliveryType && (
          <DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <FormControl>
                <InputLabel id="delivery-source-select-label">
                  Select delivery source
                </InputLabel>
                <Select
                  labelId="delivery-select-source"
                  style={
                    state.deliverySource === "Distributor"
                      ? { width: 200, marginRight: 30 }
                      : { width: 300 }
                  }
                  value={state?.deliverySource ?? ""}
                  onChange={event => {
                    setState({
                      ...state,
                      deliverySource: event.target.value,
                      orderToDeliver: undefined
                    });
                  }}
                >
                  <MenuItem value="Distributor">Distributor</MenuItem>
                  {!hasRole(user, ["DistributorManager"]) && (
                    <MenuItem value="Order">Order</MenuItem>
                  )}
                </Select>
              </FormControl>

              {state.deliverySource === "Distributor" && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    setState({
                      ...state,
                      showScanner: true,
                      chooseDeliveryType: false,
                      scanning: true
                    });
                  }}
                >
                  Scan
                </Button>
              )}
            </div>

            {state.deliverySource === "Order" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 15
                }}
              >
                <StoreOrderSelect
                  className={classes.select}
                  storeId={state.selectedStoreId}
                  onSelected={async order => {
                    setState({ ...state, isLoadingOrder: true });
                    const result = await StoreOrderApi.getOrder(order.id);
                    if (result.type === "OK") {
                      setState({
                        ...state,
                        isLoadingOrder: false,
                        orderToDeliver: {
                          ...result.value,
                          items: result.value.items
                            .filter(i => !i.delivered)
                            .map(i => {
                              i.productId = i.product.id;
                              i.currentlyOnShelf = i.onShelfBeforeDelivery;
                              return i;
                            })
                        }
                      });
                    }
                  }}
                  value={state.orderToDeliver?.id ?? ""}
                />
              </div>
            )}

            {state &&
              state.deliverySource === "Order" &&
              state?.isLoadingOrder && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 25
                  }}
                >
                  <CircularProgress />
                </div>
              )}

            {state && state.deliverySource === "Order" && state.orderToDeliver && (
              <div style={{ marginLeft: 10, marginRight: 10, marginTop: 25 }}>
                {state.orderToDeliver.items.length > 0 ? (
                  <div>
                    <h3>{t("common.messages.orderContainsFollowingItems")}</h3>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <TextField
                        id="search-field"
                        className={classes.searchField}
                        value={state.searchPhrase}
                        placeholder={"Input search phrase"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position={"end"}>
                              <Clear
                                style={{
                                  color: "rgba(0, 0, 0, 0.44)",
                                  cursor: "pointer"
                                }}
                                fontSize={"small"}
                                onClick={() =>
                                  setState({
                                    ...state,
                                    searchPhrase: ""
                                  })
                                }
                              />
                            </InputAdornment>
                          )
                        }}
                        onChange={e => {
                          setState({ ...state, searchPhrase: e.target.value });
                        }}
                      />
                      <Button
                        style={{ marginLeft: 10 }}
                        variant={"contained"}
                        color={"primary"}
                        startIcon={<TabletAndroid />}
                        onClick={() =>
                          setState({
                            ...state,
                            searchShowScanner: true
                          })
                        }
                      >
                        Scan
                      </Button>
                    </div>
                    {getOrderItems().map((item: StoreOrderItem) => {
                      return (
                        <div
                          style={{
                            marginBottom: 20
                          }}
                        >
                          <div style={{ marginBottom: 30 }}>
                            <Typography>{item.product.name}</Typography>
                            <Typography color="textSecondary">
                              {item.product.gtin}, {item.product.size}{" "}
                              {item.product.brandName}
                            </Typography>
                            <div>
                              <TextField
                                type="number"
                                className={classes.orderItemField}
                                label={t("common.formFields.currentlyOnShelf")}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      st
                                    </InputAdornment>
                                  )
                                }}
                                value={item?.currentlyOnShelf}
                                helperText={`According to system: ${item.onShelfBeforeDelivery}`}
                                onChange={e => {
                                  const value = parseInt(e.target.value);
                                  setState({
                                    ...state,
                                    orderToDeliver: {
                                      ...state.orderToDeliver,
                                      items: state.orderToDeliver.items.map(
                                        (i: any) => {
                                          if (
                                            i.product.id === item.product.id
                                          ) {
                                            i.currentlyOnShelf = isNaN(value)
                                              ? undefined
                                              : value;

                                            if (
                                              value != i.onShelfBeforeDelivery
                                            ) {
                                              i.discrepancyQuantity = Math.abs(
                                                (isNaN(value) ? 0 : value) -
                                                  i.onShelfBeforeDelivery
                                              );
                                            } else {
                                              i.discrepancyQuantity = undefined;
                                            }
                                          }
                                          return i;
                                        }
                                      )
                                    }
                                  });
                                }}
                              />
                              {item?.discrepancyQuantity &&
                                item.discrepancyQuantity > 0 && (
                                  <div style={{ marginTop: 10 }}>
                                    <Alert severity="warning">
                                      {`Discrepancy of ${item.discrepancyQuantity} items detected. Select a reason`}
                                    </Alert>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center"
                                      }}
                                    >
                                      <div style={{ width: "100%" }}>
                                        <SpoilageReasonSelect
                                          className={classes.field}
                                          onChange={event => {
                                            setState({
                                              ...state,
                                              orderToDeliver: {
                                                ...state.orderToDeliver,
                                                items:
                                                  state.orderToDeliver.items.map(
                                                    (i: any) => {
                                                      if (
                                                        i.product.id ==
                                                        item.product.id
                                                      ) {
                                                        i.discrepancyReasonId =
                                                          event.target.value;
                                                      }
                                                      return i;
                                                    }
                                                  )
                                              }
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              <TextField
                                className={classes.orderItemField}
                                label="Delivering"
                                type="number"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      {item.unit === OrderUnit.Kfp
                                        ? "ST/KFP"
                                        : `DFP (${
                                            item.distributionPackageSize ??
                                            "..."
                                          } st)`}
                                    </InputAdornment>
                                  )
                                }}
                                value={item?.quantity}
                                onChange={e => {
                                  const value = parseInt(e.target.value);

                                  setState({
                                    ...state,
                                    orderToDeliver: {
                                      ...state.orderToDeliver,
                                      items: state.orderToDeliver.items.map(
                                        (i: any) => {
                                          if (i.product.id == item.product.id) {
                                            i.quantity = isNaN(value)
                                              ? undefined
                                              : value;
                                          }
                                          return i;
                                        }
                                      )
                                    }
                                  });
                                }}
                              />
                              <h3>{`Total on shelf after delivery: ${calculateOrderItemQuantityAfterDeliver(
                                item
                              )}`}</h3>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  marginTop: 20
                                }}
                              >
                                <Button
                                  style={{ width: 200 }}
                                  disabled={disabled(item)}
                                  variant="contained"
                                  color="primary"
                                  onClick={async () => {
                                    const result =
                                      await StoreOrderApi.deliverItem(
                                        state.selectedStoreId,
                                        state.orderToDeliver.id,
                                        item
                                      );
                                    if (result.type === "OK") {
                                      const itemsLeftToDeliver =
                                        state.orderToDeliver.items.filter(
                                          (i: any) => i.id !== item.id
                                        );

                                      setState({
                                        ...state,
                                        saveItemSuccess: true,
                                        deliverySource:
                                          itemsLeftToDeliver.length > 0
                                            ? state.deliverySource
                                            : undefined,
                                        orderToDeliver:
                                          itemsLeftToDeliver.length > 0
                                            ? {
                                                ...state.orderToDeliver,
                                                items: itemsLeftToDeliver
                                              }
                                            : undefined
                                      });

                                      if (itemsLeftToDeliver.length === 0) {
                                        StoreOrderApi.updateOrder(
                                          state.orderToDeliver.id,
                                          StoreOrderState.Delivered
                                        );
                                      }
                                    } else {
                                      setState({
                                        ...state,
                                        saveItemFailed: true,
                                        error: result.details.detail
                                      });
                                    }
                                  }}
                                >
                                  {state.orderToDeliver.items.length > 1
                                    ? t("common.actions.deliverItem")
                                    : t("common.actions.deliverLastItem")}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <h3>
                      All the items in this order has been marked as delivered
                    </h3>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: 20
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                          const result = StoreOrderApi.updateOrder(
                            state.orderToDeliver.id,
                            StoreOrderState.Delivered
                          );
                        }}
                      >
                        Mark order as delivered
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </DialogContent>
        )}

        {state.scanning && (
          <DialogContent
            style={
              mobile
                ? {
                    position: "relative",
                    padding: "16px 0 0 0",
                    height: "calc(100vh - 120px)",
                    overflow: "hidden"
                  }
                : {
                    position: "relative",
                    padding: "16px 0 0 0",
                    height: "70vh",
                    overflow: "hidden"
                  }
            }
          >
            {state.isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px"
                }}
              >
                <CircularProgress />
                <Typography variant="body1" style={{ marginLeft: 10 }}>
                  Loading product...
                </Typography>
              </div>
            ) : (
              <>
                <div
                  style={{
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                    background: "#000"
                  }}
                >
                  {/* Scanner layer */}
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      overflow: "hidden",
                      zIndex: 0
                    }}
                  >
                    <ScanditBarcodeScanner
                      licenseKey={
                        globalSettings.settings.scandit.scannerLicenseKey
                      }
                      libraryLocation="https://cdn.jsdelivr.net/npm/@scandit/web-datacapture-barcode@8.0.0/sdc-lib/"
                      style={{ width: "100%", height: "100%" }}
                      onScan={async (data: string) => {
                        if (!data) return;
                        await loadProduct(data);
                      }}
                    />
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 9999,
                      backgroundColor: "#f5f5f5",
                      borderTop: "1px solid #ddd",
                      padding: "12px 16px",
                      paddingBottom: "max(12px, env(safe-area-inset-bottom))"
                    }}
                  >
                    <TextField
                      fullWidth
                      type="number"
                      label={t("common.formFields.manualInput")}
                      value={state.manualInput}
                      inputProps={{ style: { fontSize: 16 } }}
                      InputLabelProps={{ style: { fontSize: 16 } }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Button
                              onClick={async () => {
                                if (state.manualInput)
                                  await loadProduct(state.manualInput);
                              }}
                            >
                              OK
                            </Button>
                          </InputAdornment>
                        )
                      }}
                      onChange={e =>
                        setState({ ...state, manualInput: e.target.value })
                      }
                    />
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      height: 92
                    }}
                  />
                </div>
              </>
            )}

            {state.getItemFailed && (
              <div
                style={{
                  position: "absolute",
                  bottom: "100px",
                  left: "16px",
                  right: "16px",
                  zIndex: 1000
                }}
              >
                <Alert severity="error">{state.error}</Alert>
              </div>
            )}
          </DialogContent>
        )}

        {state.uploadProductFile && (
          <DialogContent
            style={mobile ? { padding: 0, marginTop: 15 } : { marginTop: 15 }}
          >
            <div>
              <DropzoneArea
                acceptedFiles={[
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  ".xlsx"
                ]}
                dropzoneText={"Drag and drop a file to re-stock products"}
                showPreviewsInDropzone={true}
                useChipsForPreview
                filesLimit={1}
                onChange={files => {
                  setState({
                    ...state,
                    file: files[files.length - 1],
                    uploaded: false,
                    result: null
                  });
                }}
              />
            </div>
            {state.file ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 20
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      setState({ ...state, uploading: true });
                      const result = await StoreInventoryApi.reportDeliveryFile(
                        state.selectedStoreId,
                        state.file
                      );
                      setState({ ...state, uploading: false });
                      if (isOk(result)) {
                        setState({
                          ...state,
                          hasProductDeliveryResult: true,
                          productDeliveryResult: result.value
                        });
                      } else {
                        setState({
                          ...state,
                          deliveryFailed: true,
                          deliveryResult: result.details
                        });
                      }
                    }}
                  >
                    Upload file
                  </Button>
                </div>
              </>
            ) : null}
            {state.deliveryFailed && (
              <Alert severity="error" style={{ marginTop: 20 }}>
                <AlertTitle>
                  {state.deliveryResult.status}, {state.deliveryResult.title}
                </AlertTitle>
                {state.deliveryResult.detail}{" "}
                <strong>{state.deliveryResult.traceId}</strong>
              </Alert>
            )}
            {state.hasProductDeliveryResult && (
              <>
                <ExpansionPanel variant={"outlined"} style={{ marginTop: 20 }}>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="output-content"
                    id="output-header"
                  >
                    <Typography>Output</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <List>
                      {state.productDeliveryResult.map((x: any) => (
                        <ListItem key={x}>
                          <ListItemText primary={x} />
                        </ListItem>
                      ))}
                    </List>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </>
            )}
          </DialogContent>
        )}

        {state.registeringInStore && (
          <DialogContent
            style={
              mobile
                ? { padding: 0, marginTop: 15, marginLeft: 15, marginRight: 15 }
                : { marginTop: 15 }
            }
          >
            <div>
              <Alert
                severity="warning"
                style={{ display: "flex", justifyContent: "center" }}
              >
                This product is not registered in{" "}
                <b>{state.selectedStoreName}</b>.
                {user.tenant?.configuration?.features?.digitalPriceTags
                  ? ` Click "Connect to price tag" or "Activate" to activate the product`
                  : ` Click "Activate" to activate the product`}
              </Alert>
              <div
                style={{
                  display: "flex",
                  marginTop: 20,
                  justifyContent: "center"
                }}
              >
                {user.tenant?.configuration?.features?.digitalPriceTags && (
                  <>
                    <Button
                      color="primary"
                      startIcon={<Link />}
                      variant="contained"
                      onClick={() =>
                        setState({
                          ...state,
                          showConnectToPriceTag: true,
                          storeId: state.selectedStoreId
                        })
                      }
                    >
                      Connect to price tag
                    </Button>
                    <Typography
                      variant={"body1"}
                      style={{
                        marginLeft: 15,
                        marginRight: 15,
                        alignSelf: "center"
                      }}
                    >
                      OR
                    </Typography>
                  </>
                )}

                <Button
                  style={{ width: 200 }}
                  disabled={state?.registeringProduct === true}
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    setState({ ...state, registeringProduct: true });
                    const result = await StoreInventoryApi.add(
                      state.selectedStoreId,
                      { gtin: state.manualInput }
                    );
                    if (result.type === "OK") {
                      setState({
                        ...state,
                        registeringInStore: false,
                        registeringProduct: false,
                        registeringSuccess: true
                      });
                    } else {
                      setState({
                        ...state,
                        registerFailed: true,
                        error: result.details.detail
                      });
                    }
                  }}
                >
                  Activate{" "}
                  {state?.registeringProduct === true && (
                    <CircularProgress size={20} style={{ marginLeft: 20 }} />
                  )}
                </Button>
              </div>
              {state.registerFailed && (
                <div
                  style={{
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "center"
                  }}
                >
                  <Alert severity="error">{state.error}</Alert>
                </div>
              )}
            </div>
          </DialogContent>
        )}
        {state.registeringInSystem && (
          <DialogContent
            style={
              mobile
                ? { padding: 0, marginTop: 15, marginLeft: 15, marginRight: 15 }
                : { marginTop: 15 }
            }
          >
            <div>
              <Alert
                severity="warning"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {`This product with barcode: ${state.manualInput} is not registered in
                the system`}
                {/* This product is not registered in the system */}
              </Alert>
              <div
                style={{
                  display: "flex",
                  marginTop: 20,
                  justifyContent: "center"
                }}
              >
                <Button
                  style={{ width: 200 }}
                  disabled={state?.registeringProduct === true}
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    setState({ ...state, registeringProduct: true });
                    const result = await ProductApi.lookup(state.manualInput);
                    if (result.type === "OK") {
                      setState({
                        ...state,
                        productToRegisterInSystem: result.value.product ?? {
                          ...emptyProduct(),
                          gtin: state.manualInput
                        },
                        productImage: result.value.imageData,
                        showRegisterProduct: true,
                        registeringInSystem: false,
                        registeringProduct: false
                      });
                    } else {
                      setState({
                        ...state,
                        productToRegisterInSystem: {
                          ...emptyProduct(),
                          gtin: state.manualInput
                        },
                        showRegisterProduct: true,
                        registeringInSystem: false,
                        registeringProduct: false
                      });
                    }
                  }}
                >
                  Register{" "}
                  {state?.registeringProduct === true && (
                    <CircularProgress size={20} style={{ marginLeft: 20 }} />
                  )}
                </Button>
              </div>
            </div>
          </DialogContent>
        )}
        {state.showRegisterProduct && (
          <DialogContent
            style={
              mobile
                ? { padding: 0, marginTop: 15, marginLeft: 15, marginRight: 15 }
                : { marginTop: 15 }
            }
          >
            <div>
              <TenantProductEditor
                adding={false}
                hasAlternatives={false}
                alternativeTypes={[]}
                alternativeInstances={[]}
                editingProduct={state.productToRegisterInSystem}
                image={state.productImage}
                onSave={async () => {
                  dispatch(thunkFetchProductsV2());
                  const result = await StoreInventoryApi.add(
                    state.selectedStoreId,
                    { gtin: state.manualInput }
                  );
                  if (result.type === "OK") {
                    setState({
                      ...state,
                      registeringInSystem: false,
                      showRegisterProduct: false,
                      registeringSuccess: true
                    });
                  }
                }}
              />
            </div>
          </DialogContent>
        )}
        {state.registeringSuccess && (
          <DialogContent
            style={
              mobile
                ? { padding: 0, marginTop: 15, marginLeft: 15, marginRight: 15 }
                : { marginTop: 15 }
            }
          >
            <div>
              <Alert severity="success">
                The product has been registered in{" "}
                <b>{state.selectedStoreName}</b>. Click the button below to
                start the scanner again
              </Alert>
              <div
                style={{
                  display: "flex",
                  marginTop: 20,
                  justifyContent: "center"
                }}
              >
                <Button
                  style={{ width: 200 }}
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    setState({
                      ...state,
                      registeringSuccess: false,
                      scanning: true,
                      manualInput: undefined
                    })
                  }
                >
                  Start scanning
                </Button>
              </div>
            </div>
          </DialogContent>
        )}

        {state.delivering && (
          <DialogContent
            style={
              mobile
                ? { padding: 0, marginTop: 15, marginLeft: 15, marginRight: 15 }
                : { marginTop: 15 }
            }
          >
            <div>
              <Typography>{state.deliveryItem.productName}</Typography>
              <Typography color="textSecondary">
                {state.deliveryItem.gtin}, {state.deliveryItem.size}{" "}
                {state.deliveryItem.brandName}
              </Typography>
            </div>
            <TextField
              className={classes.field}
              label={t("common.formFields.currentlyOnShelf")}
              type="number"
              value={state?.deliveryItem?.correctedOnShelf}
              helperText={`According to system: ${state.deliveryItem.onShelfBeforeDelivery}`}
              onChange={e => {
                const value = parseInt(e.target.value);

                const {
                  deliveryItem: { onShelfBeforeDelivery }
                } = state;

                let discrepancyQuantity = undefined;

                if (value != onShelfBeforeDelivery) {
                  discrepancyQuantity = Math.abs(
                    (isNaN(value) ? 0 : value) - onShelfBeforeDelivery
                  );
                }

                setState({
                  ...state,
                  discrepancyItem:
                    discrepancyQuantity === undefined
                      ? undefined
                      : {
                          ...state.discrepancyItem,
                          quantity: discrepancyQuantity
                        },
                  deliveryItem: {
                    ...state.deliveryItem,
                    correctedOnShelf: isNaN(value) ? undefined : value
                  }
                });
              }}
            />
            {state.discrepancyItem &&
              state.discrepancyItem.quantity &&
              state.discrepancyItem.quantity > 0 && (
                <div style={{ marginTop: 10 }}>
                  <Alert severity="warning">
                    {`Discrepancy of ${state.discrepancyItem.quantity} items detected. Select a reason and click Save`}
                  </Alert>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ width: "100%" }}>
                      <SpoilageReasonSelect
                        className={classes.field}
                        onChange={event => {
                          setState({
                            ...state,
                            discrepancyItem: {
                              ...state.discrepancyItem,
                              reasonId: event.target.value
                            }
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            <TextField
              className={classes.field}
              type="number"
              label={t("common.formFields.deliveredToShelf")}
              value={state?.deliveryItem?.quantityDelivered}
              onChange={e => {
                const value = parseInt(e.target.value);
                setState({
                  ...state,
                  deliveryItem: {
                    ...state.deliveryItem,
                    quantityDelivered: isNaN(value) ? undefined : value
                  }
                });
              }}
            />
            {state.deliveryItem &&
              state?.deliveryItem?.quantityDelivered > 0 && (
                <h3>{`Total on shelf after delivery: ${totalQuantityDelivered()}`}</h3>
              )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 20
              }}
            >
              <Button
                style={{ width: 200 }}
                variant="contained"
                color="primary"
                disabled={
                  state.deliveryItem.quantityDelivered == undefined ||
                  (state?.deliveryItem?.quantityDelivered === 0 &&
                    state?.discrepancyItem?.quantity > 0 &&
                    !state.discrepancyItem.reasonId)
                }
                onClick={async () => {
                  const {
                    deliveryItem: {
                      productId,
                      onShelfBeforeDelivery,
                      correctedOnShelf,
                      quantityDelivered
                    }
                  } = state;

                  const { discrepancyItem } = state || {};
                  const { quantity, reasonId } = discrepancyItem || {};

                  const result = await ProductApi.reportDelivery({
                    source: { type: "distributor" },
                    destination: {
                      type: "store",
                      id: state.selectedStoreId
                    },
                    item: {
                      productId: productId,
                      onShelfQuantityBeforeDelivery:
                        correctedOnShelf ?? onShelfBeforeDelivery,
                      onShelfQuantityDelivered: quantityDelivered
                    },
                    spoilageReport:
                      quantity && reasonId
                        ? { quantity, comment: "", reasonId: reasonId }
                        : undefined
                  });
                  if (result.type === "OK") {
                    setState({
                      ...state,
                      deliverySuccess: true,
                      discrepancyItem: undefined,
                      delivering: false
                    });
                  } else {
                    setState({
                      ...state,
                      deliveryFailed: true,
                      error: result.details.detail
                    });
                  }
                }}
              >
                Save
              </Button>
            </div>
            {state.deliveryFailed && (
              <div
                style={{
                  display: "flex",
                  marginTop: 20,
                  justifyContent: "center"
                }}
              >
                <Alert severity="error">{state.error}</Alert>
              </div>
            )}
          </DialogContent>
        )}
        {state.deliverySuccess && (
          <DialogContent>
            <div>
              <div
                style={{
                  display: "flex",
                  marginTop: 20,
                  justifyContent: "center"
                }}
              >
                <Alert severity="success">
                  {t("common.messages.itemDelivered")}
                </Alert>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 20,
                  justifyContent: "center"
                }}
              >
                <Button
                  style={{
                    width: 200
                  }}
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    setState({
                      ...state,
                      scanning: true,
                      delivering: false,
                      deliverySuccess: false,
                      item: undefined,
                      manualInput: undefined
                    });
                  }}
                >
                  Scan more items
                </Button>
              </div>
            </div>
          </DialogContent>
        )}
      </Dialog>
      <Dialog
        fullWidth={true}
        fullScreen={mobile}
        maxWidth={"md"}
        open={state.showConnectToPriceTag}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <MuiDialogTitle disableTypography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setState({ ...state, showConnectToPriceTag: false });
            }}
          >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent>
          <ConnectToPriceTag
            addToStore={true}
            storeId={state.selectedStoreId}
            gtin={state.manualInput}
            onSuccess={() =>
              setState({
                ...state,
                showConnectToPriceTag: false,
                registeringSuccess: true,
                registeringInStore: false
              })
            }
            onCancel={() =>
              setState({
                ...state,
                showConnectToPriceTag: false,
                storeId: ""
              })
            }
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
